function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e02020;}.cls-1,.cls-2,.cls-3{fill-rule:evenodd;}.cls-2,.cls-3{fill:#fff;}.cls-3{isolation:isolate;opacity:0.31;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "cls-1",
  d: "M15,0a5,5,0,0,1,5,5v6a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  className: "cls-2",
  d: "M7.68,4.07a.41.41,0,0,0-.44,0A.56.56,0,0,0,7,4.39v7.13a.52.52,0,0,0,.24.42.43.43,0,0,0,.38,0l.07,0L12.8,8.41A.48.48,0,0,0,13,8a.52.52,0,0,0-.13-.35l-.08-.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M15,0H5A5,5,0,0,0,1.11,1.9L18.52,14.55A5,5,0,0,0,20,11V5A5,5,0,0,0,15,0Z"
})));

var SvgIconVideo = function SvgIconVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-video.55b3c45f.svg";
export { ForwardRef as ReactComponent };